export default "__VITE_ASSET__JB0f6Te0__"